import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../authentication.service';
import { AccountsService } from '../../services/accounts.service';
import { ErrorService } from '../../services/error.service';
import { PersonalDetailsService } from '../../services/personal-details.service';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {

  constructor(
    private router: Router,
    private authenticationservice: AuthenticationService,
    private accountsService: AccountsService,
    private pd:PersonalDetailsService,
    private errorService: ErrorService

  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser && this.currentUser['roles'].includes('admin')) {
      this.authenticationservice.changeAdmin(false);
    } else {
      this.authenticationservice.changeAdmin(true);
    }
  }

  currentUser;
  is_Admin: boolean = false;
  account_id;
  account_name;
  profile_pic;
  is_manager;
  is_timesheet_manager: boolean;
  is_work_from_home_manager: boolean;
  is_blog_manager: boolean;
  is_reimbursement_manager: boolean;
  is_offboarding_list_enabled: boolean = false;
  is_offboarding_enabled: boolean = true;
  is_both;

  ngOnInit() {
    this.accountsService.profile_pic.subscribe(
      data => {
        this.profile_pic = data;
      }, error => {
        this.errorService.errorHandling(error);
      }
    );
    if(!!localStorage.getItem('currentUser')){
      this.account_id = JSON.parse(localStorage.getItem('currentUser')).id;
    }

    this.accountsService.accountDetails(this.account_id).subscribe(
      data => {
        let user = data.body['result'];
        if (user.is_timesheet_manager == true) {
          this.is_timesheet_manager = true;
        } else {
          this.is_timesheet_manager = false;
        }
        this.account_name = user.name;
        this.is_work_from_home_manager = user.is_work_from_home_manager;

      }, error => {
        console.log("Get Account Details Error :",error);
        
        this.errorService.errorHandling(error);
      }
    );
    this.authenticationservice.is_Admin.subscribe((val: boolean) => {
      this.is_Admin = val;
    });

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));    
    if (this.currentUser['roles'].includes('manager')) {
      this.is_manager = true;
    } else {
      this.is_manager = false;
    }
    if (this.currentUser['roles'].includes('blog_manager')) {
      this.is_blog_manager = true;
    } else {
      this.is_blog_manager = false;
    }

    if (this.currentUser['roles'].includes('reimbursement_manager')) {
      this.is_reimbursement_manager = true;
    } else {
      this.is_reimbursement_manager = false;
    }

    this.is_offboarding_list_enabled = ["admin", "manager", "reimbursement_manager"].some(
      (role) => this.currentUser["roles"].includes(role)
    );

    this.accountsService
    .getIsInitiateOnboardEnabled(this.currentUser.id.toString())
    .subscribe(
      (data) => {
        this.is_offboarding_enabled =
          !this.currentUser["roles"].includes("admin") &&
          data.body["emplyeeDetail"].is_offboarding_enabled
            ? true
            : false;
      },
      (error) => {
        console.log("Get Is Initiate Onboard Enabled Error :",error);
        this.errorService.errorHandling(error);
      }
    );
    
    this.is_both = this.currentUser["roles"].includes("manager") || this.currentUser["roles"].includes("admin") || this.currentUser["roles"].includes("reimbursement_manager")
  }
    form_data;
    form_data2;
    form_data3;

    pd_data(){
      this.pd.getPersonalDetailsForm().subscribe(
        (res:any) =>{
          this.form_data = res.body.data;
          this.form_data.forEach(ele => {
            ele.required = true;
            let arr_c = [];
            if(!!ele.options){
              ele.options.forEach(element => {
                 arr_c.push( { 'key': element, 'label': element } )
            });
            ele.options = arr_c;
            }
          });
          localStorage.setItem('pd_form',JSON.stringify(this.form_data));
        }
      )
    }

    exitform_data(){
      this.pd.getForm().subscribe(
        (res:any) =>{
          this.form_data = res.body.data;

          this.form_data.forEach(ele => {
            ele.required = true;
            let arr_c = [];
            if(!!ele.options){
              ele.options.forEach(element => {
                 arr_c.push( { 'key': element, 'label': element } )
            });

            ele.options = arr_c;
            }
          });
          localStorage.setItem('exit_form',JSON.stringify(this.form_data));
        }
      )
    }

    exitchecklist_data(){
      this.pd.getForm2().subscribe(
        (res:any) =>{
          this.form_data3 = res.body.data;
          this.form_data3.forEach(ele => {
            ele.required = true;
            let arr_c = [];

            if(!!ele.options){
              ele.options.forEach(element => {
                 arr_c.push( { 'key': element, 'label': element } )
            });
            ele.options = arr_c;
            }
          });
          localStorage.setItem('exit_checklist_employee',JSON.stringify(this.form_data3));
        }
      )
    }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  get_offb_forms(){
    if (localStorage.getItem("pd_form") === null) {
      this.pd_data();
      this.exitform_data();
      this.exitchecklist_data();
      setTimeout(() => {
        this.router.navigate(["/offboarding/personal-details"])
      }, 1500);
       
    }
    else{
      this.router.navigate(["/offboarding/personal-details"])
    }
  }

}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/layouts/sidenav/sidenav.component.ts